import UsersAPI from '../api/UsersAPI'

export default {
    data() {
        const initialNumOfFields = 3
        const sourceEmailFields = []
        for (let i = 0; i < initialNumOfFields; ++i) {
            sourceEmailFields.push({
                email: '',
                error: '',
            })
        }
        return {
            sourceEmailFields,
            initialNumOfFields,
            showEmailsCheckModal: false,
            showJoinInvitesErrorModal: false,
            showJoinInvitesErrorMessageCode: '',
            emailsCheck: {
                invited: [],
                registeredInvites: [],
                registeredOther: [],
                newInvitations: [],
            },
        }
    },

    computed: {
        formDataEmailFields() {
            return {
                emailFields: this.sourceEmailFields,
            }
        },
    },

    methods: {
        emailsChanged(ev) {
            this.sourceEmailFields = ev.value
        },
        emailsCollected(ev) {
            UsersAPI.checkJoinInvitesEmails(this.$auth.getActiveMember().id, ev, this.practiceType)
                .then((response) => {
                    this.showEmailsCheckModal = true
                    this.emailsCheck = response.emailsCheck
                })
                .catch((error) => {
                    this.showJoinInvitesErrorMessageCode = error.response.data[0].code
                    this.showJoinInvitesErrorModal = true
                })
        },
        checkInviteEmailsModalClosedHandler() {
            this.showEmailsCheckModal = false
        },
        clearEmailFormFields() {
            this.showEmailsCheckModal = false
            this.emailsCheck = {
                invited: [],
                registeredInvites: [],
                registeredOther: [],
                newInvitations: [],
            }
            this.sourceEmailFields = []
            this.emailFields = []
            for (let i = 0; i < this.initialNumOfFields; ++i) {
                this.sourceEmailFields.push({
                    email: '',
                    error: '',
                })
            }
            this.emailFields = this.sourceEmailFields
        },
        joinInvitesErrorModalClose() {
            this.showJoinInvitesErrorModal = false
        },
    },
}
